import { useRegisterSW } from 'virtual:pwa-register/react';
import { RefreshCw, Download, X } from 'lucide-react';
import { useState } from 'react';
import { usePWAInstall } from '../hooks/usePWAInstall';

interface PWAPromptProps {
  isDark: boolean;
}

export function PWAPrompt({ isDark }: PWAPromptProps) {
  const {
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker,
  } = useRegisterSW();
  const { canInstall, install } = usePWAInstall();
  const [dismissed, setDismissed] = useState(false);

  if (dismissed) return null;
  if (!needRefresh && !canInstall) return null;

  return (
    <div
      className={`fixed bottom-20 sm:bottom-6 left-4 right-4 sm:left-auto sm:right-6 sm:max-w-sm z-50 rounded-xl shadow-lg p-4 flex items-center gap-3 pb-safe ${
        isDark ? 'bg-gray-800 text-white border border-gray-700' : 'bg-white text-gray-900 border border-gray-200'
      }`}
      role="status"
      aria-live="polite"
    >
      <div className="flex-1">
        {needRefresh ? (
          <>
            <p className="font-semibold text-sm">Versi baru tersedia</p>
            <p className={`text-xs ${isDark ? 'text-gray-400' : 'text-gray-500'}`}>
              Update untuk mendapatkan fitur & perbaikan terbaru.
            </p>
          </>
        ) : (
          <>
            <p className="font-semibold text-sm">Install The Five</p>
            <p className={`text-xs ${isDark ? 'text-gray-400' : 'text-gray-500'}`}>
              Tambahkan ke layar utama untuk akses cepat & offline.
            </p>
          </>
        )}
      </div>

      {needRefresh ? (
        <button
          onClick={() => updateServiceWorker(true)}
          className="flex items-center gap-1.5 px-3 py-2 rounded-lg text-white text-sm font-medium bg-green-600 hover:bg-green-700 transition-colors"
        >
          <RefreshCw size={16} />
          Update
        </button>
      ) : (
        <button
          onClick={() => install()}
          className="flex items-center gap-1.5 px-3 py-2 rounded-lg text-white text-sm font-medium bg-green-600 hover:bg-green-700 transition-colors"
        >
          <Download size={16} />
          Install
        </button>
      )}

      <button
        onClick={() => {
          setDismissed(true);
          setNeedRefresh(false);
        }}
        className={`p-1.5 rounded-lg transition-colors ${
          isDark ? 'hover:bg-gray-700 text-gray-400' : 'hover:bg-gray-100 text-gray-500'
        }`}
        aria-label="Tutup"
      >
        <X size={16} />
      </button>
    </div>
  );
}
